// src/hooks/useDashboard.ts
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";  // Import useNavigate
import { Patient } from "../../components/Card/props";
// import { GraphData } from "./Dashboard.props";
import ApiService from "../../service/ApiService";
import { apiPaths } from "../../service/apiPaths";


const useDashboard = () => {
  const [activePatientsCount, setActivePatientsCount] = useState(0);
  const [totalPatientsCount, setTotalPatientsCount] = useState(0);
  const [inactivePatientsCount, setInactivePatientsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reportContent, setReportContent] = useState<Patient[]>([]);
  const [dashboardDetails,setDashboardDetails] = useState({totalEBooks:0,totalTest:0,allStudents:0});
  const [submissionSummary, setSubmissionSummary] = useState<any>(null);
  // const [graphData, setGraphData] = useState<GraphData>({
  //   labels: [],
  //   datasets: [
  //     {
  //       label: "Monthly Patient Count",
  //       data: [],
  //       backgroundColor: "rgba(75, 192, 192, 0.2)",
  //       borderColor: "rgba(75, 192, 192, 1)",
  //       borderWidth: 1,
  //     },
  //   ],
  // });

  const navigate = useNavigate();  // Create a navigate instance

  const fetchDashboardDetails = async () => {
    try {
      const data = await ApiService({
        method: "GET",
        endpoint: apiPaths.dashboard,
      });
      setDashboardDetails(data)
    } catch (error) {
      console.error("Error fetching DashBoard details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubmissionSummary = async () => {
    try {
      const data = await ApiService({
        method: "GET",
        endpoint: apiPaths.submissionSummary,
      });
      setSubmissionSummary(data);
    } catch (error) {
      console.error("Error fetching submission summary:", error);
    }
  };

  useEffect(() => {
    fetchDashboardDetails();
    fetchSubmissionSummary();
  }, []);

  // useEffect(() => {
  //   const fetchGraphData = async () => {
  //     try {
  //       const data = await ApiService({
  //         method: "GET",
  //         endpoint: apiPaths.getPatient,
  //       });

  //       const months = [
  //         "January", "February", "March", "April", "May",
  //         "June", "July", "August", "September", "October",
  //         "November", "December"
  //       ];

  //       const monthWiseData = new Array(12).fill(0);
  //       data.forEach((item: any) => {
  //         const month = new Date(item.date).getMonth();
  //         monthWiseData[month] += 1;
  //       });

  //       setGraphData({
  //         labels: months,
  //         datasets: [
  //           {
  //             label: "Monthly Patient Count",
  //             data: monthWiseData,
  //             backgroundColor: "rgba(75, 192, 192, 0.2)",
  //             borderColor: "rgba(75, 192, 192, 1)",
  //             borderWidth: 1,
  //           },
  //         ],
  //       });
  //     } catch (error) {
  //       console.error("Error fetching month-wise data:", error);
  //     }
  //   };

  //   fetchGraphData();
  // }, []);

  // const fetchPharmacyReport = async () => {
  //   try {
  //     const data = await ApiService({
  //       method: "GET",
  //       endpoint: apiPaths.getPharmacyReport,
  //     });
  //     setReportContent(data);
  //   } catch (error) {
  //     console.error("Error fetching pharmacy report:", error);
  //   }
  // };

  // const handleCardClick = async () => {
  //   await fetchPharmacyReport();
  //   setIsModalOpen(true);
  // };

  // const navigateToPatientsPage = () => {
  //   navigate("/patient");  // Navigate to /patient page
  // };

  return {
    activePatientsCount,
    totalPatientsCount,
    inactivePatientsCount,
    loading,
    isModalOpen,
    reportContent,
    dashboardDetails,
    submissionSummary,
    navigateToAnalysis: () => navigate("/test-submission-analysis"),
    // graphData,
    // handleCardClick,
    // navigateToPatientsPage,
    setIsModalOpen,  // Expose this to control modal visibility
  };
};

export default useDashboard;
